const assign = (url) => {
  window.location.assign(url);
};

const replace = (url) => {
  window.location.replace(url);
};

export { assign, replace };
